/**
 * Guided-planning partner sharing: the funding-sources partner hook, with each share also recorded
 * in the guided session (`stepData.partnerAllocationSelections`) and legacy partner shares read from
 * the partner's session, as guided planning always did.
 */
import {
  usePartnerAllocation as useSharedPartnerAllocation,
  type PersistedSelection,
} from '@/features/funding-sources';
import { useSession, useSessionMutations } from '@/features/guided-financial-planning/context';
import { useLegacyPartnerAllocationSelections } from './use-legacy-partner-allocation-selections';

export {
  DEFAULT_CUSTOM_CLIENT_PERCENT,
  SPLIT_RATIO_CONFIGS,
  actionToAllocationOption,
  getActionLabel,
  type AllocationAction,
  type CardAllocationState,
  type SplitRatioConfig,
} from '@/features/funding-sources';

export function usePartnerAllocation() {
  const { session } = useSession();
  const { updateStepData } = useSessionMutations();
  const legacy = useLegacyPartnerAllocationSelections();

  return useSharedPartnerAllocation({
    savedAllocationSelections: session?.stepData?.partnerAllocationSelections as
      | Record<string, PersistedSelection>
      | undefined,
    persistAllocationSelections: selections =>
      updateStepData({ partnerAllocationSelections: selections }),
    legacy,
  });
}
